import { QueryClient } from "@tanstack/react-query";
/**
* QueryClient global. Defaults conservadores para una app que toca un
* backend real (no spammeamos refetch).
*
* - staleTime 5min: datos se consideran frescos por 5 minutos
* - gcTime 30min: queries inactivas se borran a los 30 minutos
* - retry 1: un solo reintento ante error transitorio
* - refetchOnWindowFocus: refresca al volver a la tab (útil para
* historial multiusuario)
*/
export const queryClient = new QueryClient({
defaultOptions: {
queries: {
staleTime: 5 * 60_000,
gcTime: 30 * 60_000,
retry: 1,
refetchOnWindowFocus: true,
},
mutations: {
retry: 0,
},
},
});
